module.exports = __webpack_public_path__ + "static/media/img138.5cf7b6f3.jpg";